import { MessageCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Badge } from '../Badge/Badge';
import { useCrispChat } from './CrispProvider';

function formatUnread(count: number): string {
  return count > 9 ? '9+' : String(count);
}

export function CrispChatButton() {
  const { openChat, unreadCount } = useCrispChat();
  const { t } = useTranslation();
  const label =
    unreadCount > 0
      ? t('help.chatUnread', { count: unreadCount })
      : t('help.chat');

  return (
    <button
      type="button"
      onClick={openChat}
      aria-label={label}
      title={label}
      data-dd-action-name="Crisp Chat Button"
      className="inline-flex items-center gap-1.5 p-2 rounded-lg hover:bg-gray-100 transition-colors"
    >
      <span className="relative inline-flex">
        <MessageCircle className="h-5 w-5 text-gray-600" aria-hidden />
        {unreadCount > 0 ? (
          <Badge
            variant="destructive"
            className="absolute -top-1 -right-1 h-5 w-5 flex items-center justify-center text-xs p-0"
            aria-hidden
          >
            {formatUnread(unreadCount)}
          </Badge>
        ) : null}
      </span>
      <span className="hidden text-sm font-medium text-gray-700 md:inline">
        {t('help.askAnything')}
      </span>
    </button>
  );
}
